/* Service Worker registration for Discoveur PWA.
 * Behaviour:
 *  - registers /sw.js once the page has loaded
 *  - polls the registration every 60 s so a new deploy is picked up
 *    without the user having to close the tab
 *  - listens for SW_UPDATED messages and forces a single reload so
 *    the new HTML shell becomes active immediately
 */
export function registerSW() {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;

    // Skip in dev (CRA dev server doesn't serve sw.js correctly).
    const isLocal =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1";
    if (isLocal && process.env.NODE_ENV !== "production") return;

    let reloadOnce = false;

    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/sw.js")
            .then((reg) => {
                // Check for updates every minute while the tab is open.
                setInterval(() => {
                    reg.update().catch(() => {});
                }, 60 * 1000);

                // If a new SW takes control, signal the React app instead
                // of force-reloading: NewVersionBanner shows a CTA so the
                // user reloads when they're done with their current task.
                navigator.serviceWorker.addEventListener("controllerchange", () => {
                    // Event is consumed by NewVersionBanner; nothing to do
                    // here. Keeping the listener empty preserves the
                    // browser-native event semantics for the banner.
                });
            })
            .catch((err) => {
                if (process.env.NODE_ENV === "development") {
                    console.warn("SW register failed", err);
                }
            });

        navigator.serviceWorker.addEventListener("message", (event) => {
            if (event.data && event.data.type === "SW_UPDATED" && !reloadOnce) {
                // Don't auto-reload — NewVersionBanner is the user-facing
                // surface. Keeping `reloadOnce` flag in case future code
                // paths want to opt-in to silent reload.
                reloadOnce = true;
            }
            if (event.data && event.data.type === "APP_BADGE") {
                const n = Number(event.data.count) || 0;
                if ("setAppBadge" in navigator) {
                    if (n > 0) navigator.setAppBadge(n).catch(() => {});
                    else if ("clearAppBadge" in navigator) {
                        navigator.clearAppBadge().catch(() => {});
                    }
                }
            }
        });
    });
}
